import React from 'react';
import { useIntl, defineMessages } from 'react-intl';
import { Pluggable } from '@plone/volto/components/manage/Pluggable';

const messages = defineMessages({
  mainView: {
    id: 'skiplink-main-content',
    defaultMessage: 'Skip to main content',
  },
  navigation: {
    id: 'skiplink-navigation',
    defaultMessage: 'Skip to navigation',
  },
  footer: {
    id: 'skiplink-footer',
    defaultMessage: 'Skip to footer',
  },
  arialabel: {
    id: 'Skiplinks',
    defaultMessage: 'Skiplinks',
  },
});

const SkipLinks = () => {
  const intl = useIntl();

  return (
    <nav
      className="skiplinks-wrapper" 
      aria-label={intl.formatMessage(messages.arialabel)}
    >
      <a className="skiplink" href="#view">
        {intl.formatMessage(messages.mainView)}
      </a>
      <a className="skiplink" href="#navigation">
        {intl.formatMessage(messages.navigation)}
      </a>
      <a className="skiplink" href="#footer">
        {intl.formatMessage(messages.footer)}
      </a>
      <Pluggable name="main.skiplinks" />
    </nav>
  );
};

export default SkipLinks;
